import { PermissionTypes } from '@/constants/permissions'
import { MenuLinks } from '@/constants/menu'
import { usePermission } from '@/hooks/usePermission'
import { RootState } from '@/redux/store'
import { useSelector } from 'react-redux'
import { Navigate } from 'react-router-dom'
import Preloader from '@/components/Preloader'

interface Props {
	children: React.ReactNode
}

/** Custom pricing configuration is SuperAdmin (Root) only. */
const CustomPricingAdminGuard = ({ children }: Props) => {
	const { userHasPermission } = usePermission()
	const permissionsLoaded = useSelector((state: RootState) => state.Auth.permissionsLoaded)
	const canManage =
		userHasPermission(PermissionTypes.Permissions_CustomPricing_View) ||
		userHasPermission(PermissionTypes.Permissions_Tenants_View)

	if (!permissionsLoaded) {
		return <Preloader />
	}
	if (!canManage) {
		return <Navigate to={MenuLinks.Dashboard} replace />
	}

	return <>{children}</>
}

export default CustomPricingAdminGuard
